/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { render } from '../lib';
import { VmFullscreenControl, VmControl, VmIcon, VmTooltip } from '@vime/core';
import { define } from '../lib';
define('vm-fullscreen-control', VmFullscreenControl);
define('vm-control', VmControl);
define('vm-icon', VmIcon);
define('vm-tooltip', VmTooltip);
export default Vue.extend({
    props: {
        enterIcon: {},
        exitIcon: {},
        icons: {},
        tooltipPosition: {},
        tooltipDirection: {},
        hideTooltip: {},
        keys: {},
        isFullscreenActive: {},
        i18n: {},
        playbackReady: {},
    },
    methods: {},
    render: render('vm-fullscreen-control', []),
});
//# sourceMappingURL=FullscreenControl.js.map